// extracted by mini-css-extract-plugin
module.exports = {"Chip":"Chip_Chip__3pwLN","ChipBadge":"Chip_ChipBadge__o9lSo","ChipIcon":"Chip_ChipIcon__wBRcx"};